import React from "react";
import { UserAvatar } from "../../components/Atoms/Avatar";
import { fromatShortDateAndTime } from "../../utilities";
import moment from "moment";
import { DeleteDialog } from "../../components";
import NotePreview from "./NotePreview";
import NoteFull from "./NoteFull";
import CollapsiblePreview from "../../components/CollapsiblePreview/CollapsiblePreviews";
import VisibleToExternalIcon from "../../components/VisibleToExternal/VisibleToExternalIcon";
import { PhosphorPencilButton, PhosphorTrashButton } from "components/Atoms/PhosphorIconButton";

interface Props {
  canDelete: boolean
  canEdit: boolean
  note: server.dto.Note
  onDeleted: () => void
  onEdit: (note: server.dto.Note) => void
  config: server.dto.LinkedNotePanelConfig
}

const NoteRowCard = ({ note, onDeleted, onEdit, canDelete, canEdit, config }: Props) => {
  const [isDeleting, setIsDeleting] = React.useState(false);

  let collapsible = false;
  if (note.body) {
    const brIndex = note.body.indexOf("<br");
    if (brIndex > -1 || note.body.length > 100) {
      collapsible = true;
    }
  }

  const isInternalUser = site.currentEnvironment.type === "internal";

  const deleteNote = async () => {
    await window.CoreApi.Note.DeleteNote(note.noteId);
    onDeleted();
  };

  return <div>
    <div>
      <UserAvatar user={note.author} />
    </div>

    <div className="no-wrap" style={{ width: 150 }}>
      <div>{note.author.fullName}</div>
      <div className="text-sublabel">{fromatShortDateAndTime(moment.utc(note.lastModifiedLocal))}</div>
      {isInternalUser && config.showVisibleToExternalCheckbox && <VisibleToExternalIcon visibleToExternal={note.visibleToExternal} />}
    </div>

    <CollapsiblePreview
      preview={<NotePreview note={note} />}
      fullView={<NoteFull note={note} />}
      onlyShowFullView={!collapsible}
    />

    {canDelete && <PhosphorTrashButton
      layout="in-square"
      onClick={() => { setIsDeleting(true); }}
    />}

    {canEdit && <PhosphorPencilButton
      layout="in-square"
      onClick={() => { onEdit(note); }}
    />}

    <DeleteDialog
      isOpen={isDeleting}
      onDelete={deleteNote}
      handleClose={() => { setIsDeleting(false); }}
      message={RESX.GeneralWarnings.AreYouSure}
    />
  </div >;
};

export default NoteRowCard;